import React from 'react';
import { Page } from '../Common/Components/Page';
import { CompartmentDetailsContent } from './Components/CompartmentDetailsContent';

export const CompartmentDetails = (): React.JSX.Element => (
  <Page title={'Compartment Details'} accessKey={'compartments'} isSearchable={true}>
    <CompartmentDetailsContent />
  </Page>
);
